export const UPDATE_REPORTS_STATE = "UPDATE_REPORTS_STATE"
export const REPORT_DETAILS_LOADED = "REPORT_DETAILS_LOADED"
export const RC_LOAD_MORE = "RC_LOAD_MORE"
export const RC_CREATED = "RC_CREATED"
export const RC_DELETED = "RC_DELETED"
export const RC_UPDATED = "RC_UPDATED"
